<template lang="html">
  <div id="info-container">
    <div id="info-nest">
      <div id="info-content" v-if="settings" v-html="officeDescriptionHtml"></div>
      <div id="info-content" v-if="news.length">
        <span>News</span>
        <br>
        <ul>
          <li v-for="item in news" :key="item._id">
            • {{ item.text }}<a v-if="item.url" :href="item.url" target="_blank">{{ item.linkText }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { client, blocksToHtml } from '../sanity.js'

export default {
  data() {
    return {
      settings: null,
      news: [],
    }
  },
  computed: {
    officeDescriptionHtml() {
      return this.settings ? blocksToHtml(this.settings.officeDescription) : ''
    },
  },
  created() {
    var self = this
    client.fetch('*[_type == "aboutSettings" && _id == "aboutSettings"][0]{ officeDescription }')
      .then(function(s) { self.settings = s })
    client.fetch('*[_type == "newsItem"] | order(order asc){ _id, text, linkText, url }')
      .then(function(n) { self.news = n })
  },
};
</script>

<style lang="css">
ul {
	padding-top: 8px;
}

li {
	padding-bottom: 16px;
}
#info-container {
  line-height: 2.5vw;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 2vw;
  width: 100vw;
  padding-top: 7.5vh;
  padding-bottom: 7.5vh;
  /* height: 100vh; */
}

#info-nest {
  /* height: 75vh; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.info-images {
  display: block;
  height: 40vw;
  margin: 48px auto;
  /* padding: 2vw 0 2vw 0; */
}

#info-content {
  margin-top: 48px;
  margin-bottom: 48px;
}

#info-container a {
  text-decoration: underline;
}

#info-container a:hover {
  text-decoration: none;
  background-color: black;
  color: white;
}

#info-container span {
  color: white;
  background-color: black;
}

.about-highlight {
  background-color: #000;
  color: #fff;
}

@media only screen and (max-width: 768px) and (orientation: portrait) {
  #info-container {
    display: flex;
    height: auto;
    /* font-weight: bold; */
    justify-content: center;
    line-height: 6.5vw;
    font-size: 5vw;
    width: 90vw;
    padding-top: 5vh;
  }

  #info-nest {
    height: auto;
    display: flex;
    justify-content: space-between;
    /* text-align: justify; */
  }

  .info-images {
    width: 82.5vw;
    height: auto;
    /* padding: 5vh 0 5vh 0; */
  }

  #info-nest div {
    /* text-align: justify;
      text-justify: inter-word; */
    /* hyphens: auto; */
  }
}
</style>
